<template>
<div class = 'voc' v-show = 'voc.name'>
	<h3>{{voc.name.replace(/_/g," ")}}</h3>
	<p class = 'center'>
		<button type = "button" class = 'btn btn-primary btn-lg mr-3' @click = 'test'>évaluer</button>
		<button type = "button" class = 'btn btn-secondary btn-lg ml-3 d-none d-lg-inline' @click = 'edit'>modifier</button>
	</p>
	<dl class = "row">
		<dt class = 'col-6 text-right title'>{{voc.language}}</dt>
		<dt class = 'col-6 text-left title'>Français</dt>
	</dl>
	<dl class = "row items" v-for = '(term,k) in voc.terms' :key="k">
		<dt class = 'col-6 text-right'>{{term[0]}}</dt>
		<dd class = 'col-6 text-left'>{{term[1]}}</dd>
	</dl>
	
</div>
</template>


<script>
export default {
	name: 'voc',
	props: ['voc'],
	data: function() {
		return {
		
		};
	},
	methods: {
		test () {
			this.$router.push("test/"+this.voc.name)
		},
		edit () {
			this.$router.push("form/"+this.voc.name)
		}
	}
	
}
</script>

<style scoped>
dt.title{
	text-transform: uppercase;
}
dl.items{
	margin: 0;
}
</style>